"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const _ui_1 = require("@ui");
const util_1 = require("@app/util");
require("./index.scss");
const STYLES = Object.freeze({
    DEFAULT: 'default',
    UNDERLINE: 'underline',
    BORDERLESS: 'borderless',
    BORDERED: 'bordered',
});
const SIZES = Object.freeze({
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    FULL_WIDTH: 'full-width',
    LEAN: 'lean',
});
const TYPES = Object.freeze({
    PASSWORD: 'password',
    TEXT: 'text',
    NUMBER: 'number',
    EMAIL: 'email',
    TIME: 'time',
});
const Input = ({ label, style, size, disabled, errorMessage, hasError, placeholder, value, onChange, required, tabIndex, autoFocus, type, min, max, step, onBlur, onFocus, maxLength, autocomplete, disableLastpass, name, innerRef, onKeyPress, onKeyDown, extraContent, ico, onSubmit, onClick, testid, textAlignCenter = false, }) => {
    const handleKeyDown = ({ keyCode }) => {
        if (keyCode === 13)
            onSubmit?.();
    };
    const tableLeanStyle = style === STYLES.UNDERLINE && size === SIZES.LEAN
        ? { width: `${(value ? value.toString().length : 1) + 1}ch` }
        : undefined;
    return (react_1.default.createElement("div", { onClick: onClick, className: (0, classnames_1.default)('ds-input', style, size, {
            disabled,
            'has-error': hasError,
            'has-icon': !!ico,
            'has-extra-content': !!extraContent,
        }, (0, util_1.isDefined)(type)
            ? {
                [`type-${type}`]: type,
            }
            : {}) },
        label && react_1.default.createElement("div", { className: 'input-label' }, label),
        react_1.default.createElement("div", { className: 'group-container' },
            react_1.default.createElement("div", { className: 'input-container' },
                ico && react_1.default.createElement(_ui_1.Icon, { ico: ico, size: _ui_1.Icon.SIZES.SMALL }),
                react_1.default.createElement("input", { ref: innerRef, "data-testid": testid, placeholder: type === TYPES.PASSWORD && disableLastpass
                        ? undefined
                        : placeholder?.toString(), disabled: disabled, autoFocus: autoFocus, value: value === null ? '' : value, required: required, tabIndex: tabIndex, type: type, maxLength: maxLength, autoComplete: autocomplete, name: name, id: name, style: textAlignCenter
                        ? { ...tableLeanStyle, textAlign: 'center' }
                        : tableLeanStyle, "data-lpignore": disableLastpass ? true : undefined, min: min, max: max, step: step, onChange: ({ target }) => {
                        const safeValue = type === TYPES.NUMBER ? target.value.replace(',', '.') : target.value;
                        onChange?.(safeValue);
                    }, onKeyPress: (e) => onKeyPress?.(e), onKeyDown: (e) => {
                        if ((e.ctrlKey || e.metaKey) && e.key === 'a') {
                            const _target = e.nativeEvent
                                .target;
                            _target?.select();
                            e.stopPropagation();
                        }
                        onKeyDown ? onKeyDown(e) : handleKeyDown(e);
                    }, onBlur: onBlur ? ({ target }) => onBlur(target.value) : undefined, onFocus: onFocus, onWheel: type === TYPES.NUMBER
                        ? (e) => e.currentTarget.blur()
                        : undefined }),
                extraContent && size === SIZES.FULL_WIDTH && (react_1.default.createElement("div", { className: 'input-extra' }, extraContent)),
                ' '),
            extraContent && size !== SIZES.FULL_WIDTH && (react_1.default.createElement("div", { className: 'input-extra' }, extraContent)),
            ' '),
        errorMessage && hasError && react_1.default.createElement(_ui_1.Err, { message: errorMessage })));
};
exports.Input = Input;
// Input.propTypes = {
//   label: PropTypes.string,
//   style: PropTypes.oneOf(Object.values(STYLES)),
//   size: PropTypes.oneOf(Object.values(SIZES)),
//   disabled: PropTypes.bool,
//   errorMessage: PropTypes.string,
//   hasError: PropTypes.bool,
//   placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//   extraContent: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
//   ico: PropTypes.oneOf(Object.values(Icon.ICONS)),
//   required: PropTypes.bool,
//   tabIndex: PropTypes.number,
//   autoFocus: PropTypes.bool,
//   type: PropTypes.string,
//   min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
//   max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
//   step: PropTypes.number,
//   maxLength: PropTypes.number,
//   autocomplete: PropTypes.string,
//   disableLastpass: PropTypes.bool,
//   name: PropTypes.string,
//   onChange: PropTypes.func,
//   onBlur: PropTypes.func,
//   onFocus: PropTypes.func,
//   onKeyPress: PropTypes.func,
//   onKeyDown: PropTypes.func,
//   onSubmit: PropTypes.func,
//   onClick: PropTypes.func,
// }
exports.Input.defaultProps = {
    label: null,
    style: STYLES.DEFAULT,
    type: TYPES.TEXT,
    size: SIZES.MEDIUM,
    disabled: false,
    value: '',
    placeholder: '',
    hasError: false,
    extraContent: null,
    ico: undefined,
    autocomplete: 'off',
    disableLastpass: false,
    name: undefined,
    errorMessage: undefined,
    autoFocus: false,
    min: undefined,
    tabIndex: 1,
    required: false,
    onClick: () => { },
    onKeyPress: () => null,
    onKeyDown: undefined,
    onChange: () => { },
    onSubmit: () => { },
    onBlur: () => { },
    innerRef: undefined,
};
exports.Input.STYLES = STYLES;
exports.Input.TYPES = TYPES;
exports.Input.SIZES = SIZES;
